let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9WBx4")).then(() => parcelRequire('eZOQw'));